// Segmented Public / Buddies / Yours tabs with counts.
function ScopeTabs({ tabs, active, onChange }) {
  return (
    <div className="flex flex-wrap gap-2">
      {tabs.map((tab) => {
        const on = tab.key === active;
        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => onChange(tab.key)}
            className={`rounded-full px-4 py-1.5 text-sm font-semibold transition ${
              on
                ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg"
                : "bg-slate-800/80 text-slate-300 hover:bg-slate-700"
            }`}
          >
            {tab.label} <span className={on ? "text-sky-200" : "text-slate-500"}>{tab.count}</span>
          </button>
        );
      })}
    </div>
  );
}

export default ScopeTabs;
